import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { updateAnalytics } from 'utils/updateAnalytics'

interface Props {
	id: string
	name: string
	themeUnit: string
	logo: string
	changeTheme: (id: string) => void
	disabled?: boolean
}

export default function ThemeChartThemeButton({ id, name, themeUnit, logo, changeTheme, disabled }: Props) {
	const { sessionId } = useContext(CoreAdoptionContext)
	return (
		<button
			disabled={disabled}
			onClick={() => {
				changeTheme(id)
				if (sessionId) updateAnalytics({ name, type: 'theme', session_id: sessionId })
			}}
			className={`w-1/4 border p-3 ${
				themeUnit === id ? 'bg-gray-200' : ''
			} group flex items-center justify-center hover:bg-gray-200 disabled:cursor-not-allowed hover:disabled:bg-white`}
			key={id}
		>
			<div>
				<img src={logo} alt={`${name} logo`} className="group-disabled:opacity-50" style={{ maxHeight: 50 }} />
				{disabled && <span className="block text-xs font-semibold">Coming Soon</span>}
			</div>
		</button>
	)
}
